<div class="modal auto-pay-modal">
  <div class="model-container">
    <div class="modal-header">
        <h3 class="modal-heading" translate>{{data.title}}</h3>
        <h3 class="modal-heading" translate *ngIf="data?.subtitle">{{data.subtitle}}</h3>
        <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon"
          width="28" height="28">
    </div>
    <div class="modal-body">
      <div class="contents"  *ngIf="data?.customHTML" [innerHTML]="data?.customHTML">
      </div>
      <div class="modal-actions">
        <button class="button primary"  (click)="handleResult(true)" translate>
          {{data?.buttonText}}
        </button>
        <button class="button secondary"  (click)="handleResult(false)" translate>
          {{data?.buttonText2}}
        </button>
      </div>
    </div>
  </div>
</div>